import { makeEvent, SOURCE } from '../model';
import toEpochSeconds from '../timestamps';

// DriverAction -> timeline, plus legacy/synthetic shapes. Live records nest the
// fields under `data` (parsed AWSJSON); fixtures may put them at top level, so
// read `data` first and fall back to the record.
const MAP = {
  PackingSlipQuery: {
    type: 'PACKING_SLIP_SCAN',
    title: 'Packing slip submitted',
  },
  PackingSlipScan: { type: 'PACKING_SLIP_SCAN', title: 'Packing slip scanned' },
  LocationStocked: { type: 'LOCATION_STOCKED', title: 'Location stocked' },
  DriverFix: { type: 'DRIVER_FIX', title: 'Driver fix' },
  LocationUnreachable: {
    type: 'LOCATION_UNREACHABLE',
    title: 'Location unreachable',
  },
  ClearOutDecommission: {
    type: 'CLEAR_OUT_DECOMMISSION',
    title: 'Clear-out / decommission',
  },
  WastedItems: { type: 'WASTED_ITEMS', title: 'Wasted items' },
};

export function fromDriverActions(records = []) {
  const out = [];
  for (const r of records) {
    const ts = toEpochSeconds(r.timestamp);
    const d = r.data && typeof r.data === 'object' ? r.data : {};
    const pick = (k) => (d[k] !== undefined ? d[k] : r[k]);
    const m = MAP[r.actionType] || {
      type: r.actionType || 'DRIVER_ACTION',
      title: r.actionType || 'Driver action',
    };

    let summary = '';
    switch (m.type) {
      case 'DRIVER_FIX': {
        const fixType = pick('fixType');
        const wo = pick('wo');
        summary = `${fixType || 'fix applied'}${wo ? ` (WO ${wo})` : ''}`;
        break;
      }
      case 'PACKING_SLIP_SCAN': {
        const slip = pick('slipId') || pick('packingSlipId');
        summary = `Driver submitted packing slip${slip ? ` ${slip}` : ''}`;
        break;
      }
      case 'LOCATION_STOCKED': {
        const c = pick('itemCount') ?? pick('count');
        summary =
          c != null ? `Restocked — ${c} items` : 'Driver restocked location';
        break;
      }
      case 'LOCATION_UNREACHABLE':
        summary = 'Location reported unreachable';
        break;
      case 'CLEAR_OUT_DECOMMISSION':
        summary = 'Clear-out / decommission action';
        break;
      case 'WASTED_ITEMS':
        summary = `Wasted ${pick('count') ?? ''} item(s)`.trim();
        break;
      default:
        summary = '';
    }
    out.push(
      makeEvent({
        ts,
        source: SOURCE.DRIVER,
        type: m.type,
        title: m.title,
        summary,
        raw: r.data || r,
      }),
    );
  }
  return out;
}
